<template>
<div class="organisations-container">
  <h1>Organisations is currently under development</h1>
</div>

</template>

<script>
export default {

}
</script>

<style>
.organisations-container h1{
    margin:0;
}
.organisations-container{
    width:100%;
    height:100%;
    display:flex;
    justify-content: center;
    align-items: center;

}
</style>